import { render } from "./InboxDetails.vue?vue&type=template&id=084c702c"
import script from "./InboxDetails.vue?vue&type=script&lang=ts"
export * from "./InboxDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script